var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDragAndDrop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9032 6.39062H20.4688V8.91004H22.9032V6.39062ZM22.9032 11.4294H20.4688V13.9488H22.9032V11.4294ZM13.3789 17.2086C13.3789 15.5517 14.7221 14.2086 16.3789 14.2086H29.4202C31.0771 14.2086 32.4202 15.5517 32.4202 17.2086V21.822H30.4202V17.2086C30.4202 16.6563 29.9725 16.2086 29.4202 16.2086H16.3789C15.8266 16.2086 15.3789 16.6563 15.3789 17.2086V30.8445C15.3789 31.3968 15.8266 31.8445 16.3789 31.8445H22.367V33.8445H16.3789C14.7221 33.8445 13.3789 32.5014 13.3789 30.8445V17.2086ZM10.7305 21.5072H13.1649V24.0266H10.7305V21.5072ZM8.29385 21.5072H5.85938V24.0266H8.29385V21.5072ZM5.85938 16.4684H8.29385V18.9878H5.85938V16.4684ZM5.85938 11.4294H8.29385V13.9488H5.85938V11.4294ZM15.5977 6.39062H18.0321V8.91004H15.5977V6.39062ZM8.29385 6.39062H5.85938V8.91004H8.29385V6.39062ZM10.7305 6.39062H13.1649V8.91004H10.7305V6.39062ZM26.7878 27.8057L26.7878 36.9587C26.7878 37.5203 27.2278 37.9757 27.7705 37.9757C28.3133 37.9757 28.7532 37.5203 28.7532 36.9587V30.2609L40.4653 42.3816L41.855 40.9434L30.143 28.8227H36.6149C37.1577 28.8227 37.5976 28.3674 37.5976 27.8057C37.5976 27.244 37.1577 26.7887 36.6149 26.7887L27.7705 26.7887C27.2278 26.7887 26.7878 27.244 26.7878 27.8057Z",
    fill: "black",
    fillOpacity: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDragAndDrop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DragAndDrop.a56a61484028e4db498ee587cb574a3d.svg";